import React from "react";
import {calculateVisualScore} from "../utils/analysisFunctions";

// Turns an evaluation (number in pawns, or "mate N" string) into a short label
export const formatEval = (evaluation) => {
    if (evaluation === null || evaluation === undefined) return "";
    if (typeof evaluation === "number") {
        if (Number.isNaN(evaluation)) return "";
        if (evaluation === 0) return "0.0";
        return `${evaluation > 0 ? "+" : ""}${evaluation.toFixed(1)}`;
    }
    const match = String(evaluation).match(/mate (-?)(\d+)/);
    if (!match) return String(evaluation);
    if (match[2] === "0") return "#";
    return `${match[1] ? "-" : ""}M${match[2]}`;
};

export const isWhiteAhead = (evaluation) => {
    if (evaluation === null || evaluation === undefined) return true;
    if (typeof evaluation === "number") return evaluation >= 0;
    return !String(evaluation).includes("-");
};

// Vertical evaluation bar next to the board. White's share grows from white's side of the board.
const EvalBar = ({evaluation, orientation, disabled}) => {
    let whitePercent = 50;
    if (!disabled && evaluation !== null && evaluation !== undefined) {
        const score = calculateVisualScore(evaluation);
        if (score !== null && !Number.isNaN(score)) whitePercent = Math.max(3, Math.min(97, 50 + score / 2));
        if (formatEval(evaluation) === "#") whitePercent = isWhiteAhead(evaluation) ? 100 : 0;
    }
    const whiteAtBottom = orientation !== "black";
    const whiteLeads = isWhiteAhead(evaluation);
    const label = disabled ? "" : formatEval(evaluation);
    const labelAtBottom = whiteLeads === whiteAtBottom;

    return (
        <div className={`eval-bar ${disabled ? "eval-bar--disabled" : ""}`} aria-label={label ? `Evaluation ${label}` : "Evaluation"}>
            <div className="eval-bar__white" style={{
                height: `${whitePercent}%`,
                [whiteAtBottom ? "bottom" : "top"]: 0
            }}/>
            {label && (
                <div className="eval-bar__label" style={{
                    [labelAtBottom ? "bottom" : "top"]: 4,
                    color: whiteLeads ? "#2e3a2c" : "#f7f3e8"
                }}>
                    {label.replace("+", "")}
                </div>
            )}
        </div>
    );
}

export default EvalBar;
